export var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/es2015/utils/safe.js
// module id = 8303
// module chunks = 2